import type from './type';

const checkFilterProp = function(product, prop, value) {
    if(product.filterProperties[prop]) {
        const productPropValue = product.filterProperties[prop];

        if(type.isRangeValue(value)) {
            return value.isInRange(productPropValue)
        }
        else if(type.isArray(value)) {

            // если массив пустой, то фильтр не выставлен
            if(!value.length) {
                return true;
            }

            for(let i in value) {

                if(type.isRangeValue(value[i]) && value[i].isInRange(productPropValue)) {
                    return true;
                }

                if(value[i] == productPropValue) {
                    return true;
                }
            }

            // если в цикле мы не вылетели с истиной, значит возвращаем ложь
            return false;
        }
        else {
            return product.filterProperties[prop] == value
        }
    }

    // по дефолту возвращаем истину, тк нет у продукта такого фильтра,
    // а значит он не должен участвовать в фильтрации по этом фильтру

    // BB-11466, исправлена логика, противоположена предыдущему утверждения
    return false;
}

export default class Filterer {

    itemsPerPage = 6;
    currenPage = 1;
    currentLine = null;
    selectedFilters = {};
    lines = [];
    onFilterCb = [];

    constructor(data, lines) {
        this.data = data;
        this.filterdData = this.data;
        this.lines = lines;
        this.pages = Math.ceil(this.filterdData.length / this.itemsPerPage);
    }

    calculateData() {
        this.filterdData = this.data.filter(product => {

            let isFiltered = true;

            for(let prop in this.selectedFilters) {
                if(!checkFilterProp(product, prop, this.selectedFilters[prop])) {
                    isFiltered = false;
                    break;
                }
            }

            if(!isFiltered) {
                return false;
            }

            // проверяем линейки
            // смотрим что бы какая то линейка была выделена
            // и что у продукта есть принадлежность к какойто линейке
            if(this.currentLine && type.isArray(product.lines) && product.lines.length) {
                // если нет текущей линейка у принадлежности продукта
                if(product.lines.indexOf(this.currentLine.id) === -1) {
                    // убираем
                    return false;
                }
            }

            if(isFiltered) {
                return true;
            }

            return false;
        });

        this.pages = Math.ceil(this.filterdData.length / this.itemsPerPage)

        if(this.onFilterCb.length) {
            for(let i = 0, len = this.onFilterCb.length; i < len; i++) {
                this.onFilterCb[i](this.selectedFilters, this.currentLine);
            }
        }
    }

    onUpdate(cb) {
        if(typeof(cb) === 'function') {
            this.onFilterCb.push(cb);
        }
    }

    setFilters(selectedFilters, isResetPage = true) {
        this.selectedFilters = selectedFilters;
        this.currenPage = isResetPage ? 1 : this.currenPage;

        this.calculateData();
    }

    hasFilters() {
        return Object.keys(this.selectedFilters).length > 0;
    }

    updateFilter(propertyId, value) {
        this.selectedFilters[propertyId] = value;
        this.currenPage = 1;

        this.calculateData();
    }

    setLine(lineId) {
        if(type.isNumber(lineId, true, false)) {
            for(let i = 0, len = this.lines.length; i < len; i++) {
                if(this.lines[i].id === lineId) {
                    this.currentLine = this.lines[i];

                    this.calculateData();
                    break;
                }
            }
        }
        else if(lineId === null) {
            this.currentLine = null;
            this.calculateData();
        }
    }

    setPage(page) {
        this.currenPage = Math.min(this.pages, page);

        this.calculateData();
    }

    incrementPage() {
        this.currenPage = Math.min(this.currenPage+1, this.pages);

        this.calculateData();
    }

    isLastPage = () => {
        return this.currenPage === this.pages || this.pages < 1;
    }

    getData(page) {
        let startIndex = this.itemsPerPage * (this.currenPage - 1);
        return Array.prototype.slice.call(this.filterdData, 0, startIndex + this.itemsPerPage)
    }

    getPages() {
        return this.pages;
    }

    getCurrentPage() {
        return this.currenPage;
    }
}
